module.exports = __webpack_public_path__ + "img/item_1.d2ccefdd.png";